module.exports = __webpack_public_path__ + "static/media/a24.2db0e9ee.pdf";